<template>
  <v-btn
    class="share-folder-button"
    fab
    icon
    v-bind="sizeProps"
    @click.native.stop.prevent="$emit('share')"
  >
    <v-icon :color="isShared ? 'primary' : 'grey'">share</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'ShareFolderButton',
  props: {
    isShared: Boolean,
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    sizeProps() {
      return {
        xSmall: this.size === 'x-small',
        small: this.size === 'small',
        large: this.size === 'large',
        xLarge: this.size === 'x-large',
      };
    },
  },
};
</script>

<style>
.share-folder-button {
  .v-icon {
    font-size: 20px !important;
  }

  &.v-size--x-small {
    .v-icon {
      font-size: 18px !important;
    }
  }
}
</style>
